
const USER_ID_LENGTH = 28
const USER_ID_CHAR_LIST = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
  .sort() // shouldn't be necessary, but just in case

function getUserIdDivider(fraction, charCount) {
  if (charCount <= 0) return ''
  const charNumber = fraction * USER_ID_CHAR_LIST.length
  const char = USER_ID_CHAR_LIST[Math.floor(charNumber)]
  return `${char}${getUserIdDivider(charNumber % 1, charCount - 1)}`
}

exports.getAbDividerList = function(variantCount) {
  if (!variantCount) throw new Error(`getAbDividerList: invalid variant count "${variantCount}"`)
  return [...Array(variantCount)]
    .map((_, i) => getUserIdDivider(i / variantCount, USER_ID_LENGTH))
    .slice(1)
}

// polyfill since Node only added this in v18
function findLastIndex(array, condition) {
  for (let i = array.length - 1; i >= 0; i -= 1) {
    if (condition(array[i], i, array)) return i
  }
  return -1
}

exports.getAbNumber = function(userId, variantCount) {
  if (!userId || (userId.length !== USER_ID_LENGTH) || userId.split('').some(char => !USER_ID_CHAR_LIST.includes(char))) throw new Error(`getAbNumber: invalid user ID "${userId}"`)
  const dividerList = exports.getAbDividerList(variantCount)
  return findLastIndex(dividerList, divider => userId >= divider) + 1
}

exports.abTest = function(userId, variantList) {
  return variantList[exports.getAbNumber(userId, variantList.length)]
}
